import { Route, RawLocation } from "vue-router";
import {
  isSegmentUnit,
  pemeriksaanRouteNameForSegment,
  PemeriksaanRouteName
} from "@/utils/unit";

export const ACTING_UNIT_QUERY = "unit";

const PEMERIKSAAN_ROUTES: ReadonlyArray<string> = [
  "pemeriksaan",
  "pemeriksaan-ranap"
];

export interface ActingUnitParam {
  unitId: string;
  register: string;
}

export function isPemeriksaanRoute(route: Route | null | undefined): boolean {
  return !!route && PEMERIKSAAN_ROUTES.includes(String(route.name));
}

export function parseActingUnitParam(
  route: Route | null | undefined
): ActingUnitParam | null {
  if (!isPemeriksaanRoute(route)) return null;

  const raw = route.query ? route.query[ACTING_UNIT_QUERY] : null;
  const unitId = Array.isArray(raw) ? raw[0] : raw;
  const kode = (unitId || "").toString().trim().toUpperCase();

  if (!kode || !isSegmentUnit(kode)) return null;

  return { unitId: kode, register: String(route.params.register || "") };
}

export function correctPemeriksaanRoute(
  route: Route,
  opts?: { hasRanapSegment?: boolean }
): RawLocation | null {
  const seg = parseActingUnitParam(route);
  if (!seg) return null;

  const want: PemeriksaanRouteName = pemeriksaanRouteNameForSegment(
    seg.unitId,
    opts
  );
  if (want === route.name) return null;

  return { name: want, params: route.params, query: route.query };
}

interface RegisterLikeJurnal {
  unit?: string | null;
  unit_asal?: string | null;
  jurnal_ranap?: Array<{ unit?: { id?: string | null } | null }> | null;
}

export function registerSegmentUnitIds(
  register: RegisterLikeJurnal | null | undefined
): string[] {
  if (!register) return [];

  const jurnal = (register.jurnal_ranap || []).map(j =>
    j && j.unit ? j.unit.id : null
  );

  const semua = [register.unit_asal, ...jurnal, register.unit];
  const unik: string[] = [];

  semua.forEach(k => {
    const kode = (k || "").toString().trim().toUpperCase();
    if (kode && isSegmentUnit(kode) && !unik.includes(kode)) unik.push(kode);
  });

  return unik;
}

interface DaftarPasienRowLike {
  status_visit?: string | null;
  unit?: { id?: string | null } | null;
}

export function actingUnitQueryForListRow(
  row: DaftarPasienRowLike | null | undefined
): Record<string, string> {
  if (!row || row.status_visit === "batal" || !row.unit) return {};

  const kode = (row.unit.id || "").toString().trim().toUpperCase();
  if (!kode || !isSegmentUnit(kode)) return {};

  return { [ACTING_UNIT_QUERY]: kode };
}

export function buildPemeriksaanLocation(
  register: string | number,
  rm: string | number,
  unitId: string,
  opts?: { hasRanapSegment?: boolean }
): RawLocation {
  return {
    name: pemeriksaanRouteNameForSegment(unitId, opts),
    params: { register: String(register), rm: String(rm) },
    query: { [ACTING_UNIT_QUERY]: unitId }
  };
}
